import {of as observableOf,  Observable } from 'rxjs';
import { Injectable } from "@angular/core";
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateChild } from "@angular/router";
import { AccountService } from "app/core/services/account.service";

@Injectable()
export class AuthorizationGuard implements CanActivateChild {
	constructor(
		private _router: Router,
		private accountService: AccountService
	) { }
	canActivateChild(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<boolean> {
		if (!route.params["id"]) return observableOf(true);
		else {
			 //return this.accountService.canAccess(route.params['id']).map(result=>{
			 //    if (!result) {
			 //        this._router.navigate(['/account/unauthorized']);
			 //        return false;
			 //    }
			 //    return true;
			 //});
			return observableOf(true);
		}
	}
}